import { CURRENT_COUNTRY } from "src/constants/Countries";
import { LOCALE_TYPE_BY_COUNTRY } from "src/constants/Locales";

export const getLocaleTypeByCountry = (itemName: string): string => {
  return LOCALE_TYPE_BY_COUNTRY[CURRENT_COUNTRY]?.[itemName];
};
